<template>
  <div>
    <vehicles-edit></vehicles-edit>
  </div>
</template>

<script>
import vehiclesEdit from "@/components/ecologist/classifiers/vehicles/vehiclesEdit";
export default {
  name: "vehiclesEditView",
  components: { vehiclesEdit },
};
</script>

<style scoped></style>
